import React from 'react';
import { useNavigate } from 'react-router-dom';
import DisponibilitesCalendar from './DisponibilitesCalendar';
import './calendar.css';

function CalendrierPage() {
  const navigate = useNavigate();

  return (
    <div className="calendrier-page-container">
      <div className="header-section">
        <h1> Mon calendrier</h1>
        <p>Consultez vos disponibilités, rendez-vous et propositions en un seul endroit.</p>
        <button className="btn-retour" onClick={() => navigate('/professional/dashboard')}>
          ← Retour au tableau de bord
        </button>
      </div>

      <div className="calendar-section">
        <DisponibilitesCalendar />
      </div>
    </div>
  );
}

export default CalendrierPage;